import { useEffect, useState, useCallback } from "react";
import { api } from "../../../lib/api";
import { MarkAttendanceForm } from "./MarkAttendanceForm";
import { AbsentPanel } from "./AbsentPanel";
import { HrSelfAttendance } from "./HrSelfAttendance";
import { AttendanceTable } from "./AttendanceTable";

const today = () => new Date().toISOString().slice(0, 10);

export const RecordsTab = () => {
  const [date, setDate] = useState(today());
  const [records, setRecords] = useState([]);
  const [showMark, setShowMark] = useState(false);
  const [version, setVersion] = useState(0);

  const load = useCallback(() => api.get("/attendance", { params: { date_str: date } }).then((r) => setRecords(r.data)), [date]);
  useEffect(() => { load(); }, [load, version]);

  const onMarked = (markedDate) => {
    setShowMark(false);
    if (markedDate === date) setVersion((v) => v + 1); else setDate(markedDate);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-3">
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="attendance-date-picker"
          className="min-h-[44px] px-4 rounded-lg border border-stone-300 bg-white" />
        <button onClick={() => setShowMark(!showMark)} data-testid="toggle-mark-attendance"
          className={`tap-scale px-5 py-2.5 rounded-full text-sm font-bold transition-colors duration-200 ${showMark ? "bg-white border border-stone-300 text-stone-600" : "bg-primary text-white hover:bg-[#A63F07]"}`}>
          {showMark ? "Close" : "Mark attendance for employee"}
        </button>
      </div>

      {showMark && <MarkAttendanceForm onMarked={onMarked} />}

      <HrSelfAttendance onChanged={() => setVersion((v) => v + 1)} />

      <AbsentPanel date={date} version={version} onMarked={onMarked} />

      <AttendanceTable records={records} />
    </div>
  );
};
